import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "grid grid-cols-3 gap-6 w-full" }
const _hoisted_2 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4 grid-flow-col grid-rows-4" }
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-4 grid-flow-col grid-rows-4" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "grid grid-cols-3 gap-6 w-full mt-6" }
const _hoisted_9 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_10 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_16 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_17 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

import { // store
		localesStore
	} from '@/store/locales'

	import {
		store as _valueListStore
	} from '@/store/valueLists'

	import { // vue
		computed,
		inject,
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'RoleCovidRestrictions' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		role: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const valueListStore = _valueListStore()

	const filesLoading = ref(true)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	onMounted(async () => {
		fetchSceneMedia()
	})

	async function fetchSceneMedia() {
		try { // fetching covid restrictions image and video from s3
			filesLoading.value = true
			const s3JsonPhoto = 
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::s3JSONPictureCovid'] ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::s3JSONPictureCovid'] ||
				props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::s3JSONPictureCovid'] ||
				props.role?.['job__JOBS_ROLES__standardJobID::s3JSONPictureCovid'] ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID::s3JSONPictureCovid'] ||
				props.role?.['job__JOBS_ROLES__liveJobID::s3JSONPictureCovid']

			const s3JsonVideo =
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::s3JSONVideoCovid'] ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::s3JSONVideoCovid'] ||
				props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::s3JSONVideoCovid'] ||
				props.role?.['job__JOBS_ROLES__standardJobID::s3JSONVideoCovid'] ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID::s3JSONVideoCovid'] ||
				props.role?.['job__JOBS_ROLES__liveJobID::s3JSONVideoCovid']

			signedUrlPhoto.value = await fetchS3File(s3JsonPhoto)
			signedUrlVideo.value = await fetchS3File(s3JsonVideo)
		}
		catch(e) {
			console.error(e)
		}
		finally {
			filesLoading.value = false
		}
	}

	const covidService = computed(() => {
		
		let vl
		switch(store.locales.selected) {
		case 'en':
			vl = valueListStore.valueList.covidRestrictionsEn
			break
		case 'ja':
			vl = valueListStore.valueList.covidRestrictionsJa
			break
		case 'kana':
			vl = valueListStore.valueList.covidRestrictionsKana
			break
		default:
			vl = valueListStore.valueList.covidRestrictionsEn
		}

		let restrictions = []
		for(let i = 0; i < vl.length ; i++) {
			const value = vl[i].value
			restrictions.push({label: value, checked: false},)
		}

		restrictions.forEach(restriction => {
			if(props.role?.['job__JOBS_ROLES__instrumentalJobID::covid_service']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::covid_service']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::covid_service']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::covid_service']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__standardJobID::covid_service']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__liveJobID::covid_service']?.includes(restriction.label)) {
				restriction.checked = true
			}
		})


		return restrictions
	})

	const covidRehearsal = computed(() => {
		let vl
		switch(store.locales.selected) {
		case 'en':
			vl = valueListStore.valueList.covidRehearsalRestrictionsEn
			break
		case 'ja':
			vl = valueListStore.valueList.covidRehearsalRestrictionsJa
			break
		case 'kana':
			vl = valueListStore.valueList.covidRehearsalRestrictionsKana
			break
		default:
			vl = valueListStore.valueList.covidRehearsalRestrictionsEn
		}

		let restrictions = []

		for(let i = 0; i < vl.length ; i++) {
			const value = vl[i].value
			restrictions.push({label: value, checked: false},)
		}

		restrictions.forEach(restriction => {
			if(props.role?.['job__JOBS_ROLES__instrumentalJobID::covid_rehearsal']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::covid_rehearsal']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::covid_rehearsal']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::covid_rehearsal']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__standardJobID::covid_rehearsal']?.includes(restriction.label) ||
				props.role?.['job__JOBS_ROLES__liveJobID::covid_rehearsal']?.includes(restriction.label)) {
				restriction.checked = true
			}
		})

		return restrictions
	})

return (_ctx: any,_cache: any) => {
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_data_display, {
          label: _unref(store).getLabel('260')
        }, {
          custom: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covidService.value, (restriction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: restriction.label,
                  class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !restriction.checked}])
                }, [
                  (restriction.checked)
                    ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                        key: 0,
                        class: "h-5 w-5"
                      }))
                    : (_openBlock(), _createBlock(_component_MinusIconMini, {
                        key: 1,
                        class: "h-5 w-5"
                      })),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(restriction.label), 1)
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_data_display, {
          label: _unref(store).getLabel('261')
        }, {
          custom: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covidRehearsal.value, (restriction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: restriction.label,
                  class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !restriction.checked}])
                }, [
                  (restriction.checked)
                    ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                        key: 0,
                        class: "h-5 w-5"
                      }))
                    : (_openBlock(), _createBlock(_component_MinusIconMini, {
                        key: 1,
                        class: "h-5 w-5"
                      })),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(restriction.label), 1)
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_data_display, {
          label: _unref(store).getLabel('293')
        }, {
          custom: _withCtx(() => [
            (filesLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10))
              : (signedUrlPhoto.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "object-cover w-96 h-75 rounded-md",
                    src: signedUrlPhoto.value
                  }, null, 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_data_display, {
          label: _unref(store).getLabel('294')
        }, {
          custom: _withCtx(() => [
            (filesLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16))
              : (signedUrlVideo.value)
                ? (_openBlock(), _createElementBlock("video", _hoisted_17, [
                    _createElementVNode("source", {
                      type: "video/mp4",
                      src: signedUrlVideo.value
                    }, null, 8, _hoisted_18)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ])
  ], 64))
}
}

})